import castArray from "lodash/fp/castArray";
import flow from "lodash/fp/flow";
import filter from "lodash/fp/filter";
import get from "lodash/fp/get";
import head from "lodash/fp/head";
import map from "lodash/fp/map";

import { shouldBeDisplayed } from "utils";

export default function getLabel({ label = [], userChoiceValues = {} }) {
  return flow(
    castArray,
    map((strOrObj) => {
      return typeof label === "string" ? { label: strOrObj } : strOrObj;
    }),
    filter(shouldBeDisplayed(userChoiceValues)),
    head,
    get("label")
  )(label);
}
